export default "__VITE_ASSET__DngT4PX4__"